import React from 'react';
import { object, string } from 'prop-types';
import Field from 'redux-form/es/Field';
import auTypes from 'consts/loan/loanPaymentsFrequency';
import InputField from 'components/Credit24/Core/Controls/InputField';
import InputToggleGroup from 'components/Credit24/Core/Controls/InputToggleGroup';

const InputWithGroup = ({ inputName, groupName, errorValues }) => (
  <div className="followup__question-group-with-input">
    <div className="followup__question-group-with-input--container">
      <Field
        name={inputName}
        component={InputField}
        prefix="$"
        useDigitsGrouping
        isErrorVisible
        errorValues={errorValues}
      />
    </div>

    <InputToggleGroup
      name={groupName}
      list={auTypes}
    />
  </div>
);

InputWithGroup.propTypes = {
  inputName: string,
  groupName: string,
  errorValues: object,
};

export default InputWithGroup;
